const topics = [
  { name: '藏海花', heat: '热搜', count: '128万讨论' },
  { name: '长相思第二季', heat: '爆', count: '256万讨论' },
  { name: '唐朝诡事录', heat: '热', count: '89万讨论' },
  { name: '飞驰人生2', heat: '新', count: '67万讨论' },
  { name: '歌手2024', heat: '热', count: '198万讨论' },
  { name: '热辣滚烫', heat: '热搜', count: '145万讨论' },
  { name: '孤舟', heat: '新', count: '42万讨论' },
  { name: '奔跑吧', heat: '热', count: '112万讨论' },
  { name: '甄嬛传', heat: '经典', count: '89万讨论' },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="py-16 md:py-24 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-5xl mx-auto">
        <div className="text-center mb-12 md:mb-16">
          <h2 className="font-heading font-bold text-2xl md:text-4xl text-foreground-950 mb-3">热门话题</h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-2xl mx-auto">
            当前全网讨论热度最高的影视话题，看看大家都在聊什么
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-3 md:gap-4">
          {topics.map((topic, i) => (
            <div
              key={i}
              className="group inline-flex items-center gap-2 px-5 py-3 rounded-full bg-background-100 border border-background-200/70 hover:border-primary-200 hover:bg-primary-50 transition-all duration-300 cursor-pointer"
            >
              <span className="font-medium text-sm md:text-base text-foreground-800 group-hover:text-primary-700 whitespace-nowrap">
                #{topic.name}
              </span>
              <span className={`px-2 py-0.5 rounded-md text-xs font-bold whitespace-nowrap ${
                topic.heat === '热搜' ? 'bg-primary-100 text-primary-700' :
                topic.heat === '爆' ? 'bg-accent-200 text-accent-800' :
                topic.heat === '热' ? 'bg-secondary-100 text-secondary-700' :
                topic.heat === '新' ? 'bg-accent-100 text-accent-700' :
                'bg-background-200 text-foreground-600'
              }`}>
                {topic.heat}
              </span>
              <span className="text-xs text-foreground-500 whitespace-nowrap">{topic.count}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}